import { render, staticRenderFns } from "./createRestaurantForm.vue?vue&type=template&id=161f3b76&scoped=true&"
import script from "./createRestaurantForm.vue?vue&type=script&lang=js&"
export * from "./createRestaurantForm.vue?vue&type=script&lang=js&"
import style0 from "./createRestaurantForm.vue?vue&type=style&index=0&id=161f3b76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161f3b76",
  null
  
)

export default component.exports